<template>
  <div class="animated fadeIn list-of-unearnsettle">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="posting()">Posting</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"
            ><i class="fa fa-filter"></i> Filter</b-button
          >
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close</b-button
          >
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Transfer Date</label></b-input-group-prepend
                >
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend
                  ><span class="input-group-text"
                    >until</span
                  ></b-input-group-prepend
                >
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
            
          </b-row>
          <b-row>
           
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Customer &nbsp;</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.customer"
                  placeholder="Customer (% for wildcard)"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Customer No (CIF) &nbsp;</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.customer"
                  placeholder="Customer No (% for wildcard)"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend
              ><label>Trf Number</label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.nomor"
              placeholder="Transfer No (% for wildcard)"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Description</label></b-input-group-prepend
            >
            <b-form-input v-model="tblData.uraian" placeholder="Uraian (% for wildcard)"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Prepaid Trf From </label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.no_kontrak_from"
              placeholder="Loan No. (% for wildcard)"
            ></b-form-input>
            <b-input-group-prepend
                  ><span class="input-group-text"
                    >To</span
                  ></b-input-group-prepend
                >
            <b-form-input
              v-model="tblData.no_kontrak_to"
              placeholder="Loan No. (% for wildcard)"
            ></b-form-input>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend
                  ><label
                    >Status Posting&nbsp;</label
                  ></b-input-group-prepend
                >
                <b-form-select
                  v-model="tblData.posting"
                  :plain="true"
                  :options="dataList.postingStatus"
                ></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <div style="text-align: right; margin-top: 5px">
                <b-button variant="success" size="sm" @click="refresh()">
                  <i class="fa fa-refresh"></i> Apply Filter</b-button
                >
                <b-button
                  variant="secondary"
                  size="sm"
                  class="ml-2"
                  @click="clearFilter()"
                  >Clear Filter</b-button
                >
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:thead-top="data">
          <b-tr>
             <b-th colspan="3" class="text-center"
              >DEBITUR</b-th
            >
            <b-th variant="primary" colspan="5" class="text-center"
              >PREPAID TRANSFER</b-th
            >
            <b-th variant="dark" colspan="3" class="text-center"
              >PREPAID RECEIPT</b-th
            >
          </b-tr>
        </template>
        <template v-slot:cell(action)="data">
          <b-dropdown
            dropright
            variant="outline-secondary"
            toggle-class="text-decoration-none"
            no-caret
            size="sm"
            style="margin: -10px"
          >
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item
              @click="rowPost(data.item)"
              href="#"
              :disabled="data.item.posting == 1"
              style="padding: 0 !important;margin-top:10px;"
              >Posting</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPost(data.item)"
              href="#"
              :disabled="data.item.posting == 0"
              style="padding: 0 !important"
              >Un Posting</b-dropdown-item
            >
            <!-- <b-dropdown-item
              @click="rowPrint(data.item)"
              href="#"
              :disabled="data.item.posting == 0"
              style="padding: 0 !important"
              >Print JV</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowDel(data.item)"
              href="#"
              :disabled="data.item.posting == 1"
              style="padding: 0 !important"
            >
              Delete</b-dropdown-item
            > -->
          </b-dropdown>
        </template>
        <template v-slot:empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template v-slot:emptyfiltered="scope">
          <h6>{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(paymno)="data">
          <div v-if="data.item.posting == 0" style="background-color: yellow">
            {{ data.item.paymno }}
          </div>
          <div v-else>{{ data.item.paymno }}</div>
        </template>

        <template v-slot:cell(transferDate)="data">
          {{ data.item.transferDate | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(pbb_trf)="data">
          {{ data.item.pbb_trf | numFormat }}
        </template>
        <template v-slot:cell(post_date)="data">
          {{ data.item.post_date | moment("DD MMM YYYY") }}
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label-cols="3"
            label="Limit per page"
            style="margin-top: 0 !important"
          >
            <b-form-select
              :options="[10, 20, 30, 50, 70, 90, 120]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="width: 80px"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="showPostingConfirm"
      title="Posting Record?"
      :centered="true"
      @ok="postingData"
    >
      <p class="mb-1">
        The selected a row of data will be Posted to Accounting?
      </p>
      <p class="font-weight-bold m-0 text-danger">
        You can unpost as long as <strong>Accounting Periode</strong> stil open
      </p>
    </b-modal>
    <b-modal
      v-model="showUnpostConfirm"
      title="Un Posting Record?"
      :centered="true"
      @ok="unpostData"
    >
      <p class="mb-1">
        The selected a row of data will be UnPosted from Accounting?
      </p>
      <p class="font-weight-bold m-0 text-danger">
        Data Journal will be removed from <strong>Accounting</strong>
      </p>
    </b-modal>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      hide-footer
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
      <b-row class="justify-content-center mt-1">
        <b-button
          variant="primary"
          v-if="isprintjv == true"
          @click.stop="editjv"
          >Edit Journal</b-button
        >
        <b-button variant="secondary" class="ml-2" @click="showReport = false">
          Close</b-button
        >
      </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-unearnsettle {
  table {
    td:nth-child(1) {
      width: auto;
    }
    td:nth-child(2) {
      width: auto;
    }
    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 120px;
    }
  }
}
.dropdown-menu{
      overflow-x: auto !important;
}
.dropdown-menu.show {
    min-height: 80px !important;
}

</style>


<script>
import arrsettl from "../../apis/arsettlement";
import dropdown from "../../data/dropdown";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      showFilter: true,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      horizontal: true,
      isLoading: false,
      isprintjv: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: {},
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        tgl1: moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
          .startOf("year")
          .format("YYYY-MM-DD"),
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "transferDate",
        sortDesc: true,
        customer:'',
        custcode:'',
        nomor:'',
        uraian:'',
        no_kontrak_from:'',
        no_kontrak_to:'',
        posting:-1
      },
      dataList: {
        postingStatus: dropdown.postingStatus,
      },
    };
  },
  components: { Loading },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:20px",
          thClass: "text-center",
        },
        {
          key: "custcode",
          label: "CIF",        },
        {
          key: "CustName",
          label: "Debitur Name",
        },
        {
          key: "paymno",
          label: "Transfer No #",
          thStyle: "width:120px",
          sortable: true,
        },
        {
          key: "transferDate",
          label: "Transfer Date",
          sortable: true,
        },
        {
          key: "no_agreement_from",
          label: "No Agreement",
          variant: "primary",
          sortable: true,
        },
        {
          key: "no_kontrak_from",
          label: "Loan No",
          sortable: true,
        },
        {
          key: "uraian",
          label: "Description",
        },
        {
          key: "no_agreement_to",
          label: "No Agreement",
          variant: "primary",
          sortable: true,
        },
        {
          key: "no_kontrak_to",
          label: "Loan No",
          sortable: true,
        },
        {
          key: "pbb_trf",
          label: "Transfer Amount",
          variant: "primary",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "createby",
          label: "Issued By"
        },
        {
          key: "post_date",
          label: "Issued Date"
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(
        (d) => d.value === newval
      ).text;
    },
  },
  // created: async function(){
  //       const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
  //       this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
  //       this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
  // },
  methods: {
    data: async function (ctx) {
      try {
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.unearnsettle) {
          this.tblData[key] = filter.unearnsettle[key];
          filtered = true;
        }
        if (filtered === true) {
          this.tblData.tgl1 = filter.unearnsettle.tgl1 || "";
          this.tblData.tgl2 = filter.unearnsettle.tgl2 || "";
          this.showFilter = filtered;
          delete filter.unearnsettle;
          this.$store.commit("filter", filter);
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const list = await arrsettl.transferlist(this.tblData);
        return list;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.namabank = "";
      this.tblData.reference = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.customer = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
      this.tblData.tgldue1 = "";
      this.tblData.tgldue2 = "";
      this.tblData.status = "";
      this.$forceUpdate();
    },
    saveFilter() {
      const keys = [
        "uraian",
        "DimCol",
        "DimVal",
        "tgl1",
        "tgl2",
        "status",
        "nomor",
        "customer",
        "namabank",
        "reference",
        "tgldue1",
        "tgldue2",
      ];
      let filtered = false;
      const unearnsettle = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          unearnsettle[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        unearnsettle.page = this.tblData.page;
        unearnsettle.limit = this.tblData.limit;
        unearnsettle.sortBy = this.tblData.sortBy;
        unearnsettle.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.unearnsettle = unearnsettle;
        this.$store.commit("filter", filter);
      }
    },
    rowPost(record) {
      this.rowClicked(record);
      this.posting();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.printjv();
    },
    add() {
      this.saveFilter();
      router.push({ name: "loan.pbbtransferfrm" });
    },
    rowClicked(record, index) {
      // if (this.model.settleKey == record.settleKey) {
      //     this.edit();
      // } else {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      // }
    },
    posting: async function () {
      if (this.model) {
        if ((this.model.posting || 0) == 0) {
          this.showPostingConfirm = true;
        }
        if (this.model.posting == 1) {
          this.showUnpostConfirm = true;
        }
      } else {
        toastr.warn("Please select a row that want to be Posted!");
      }
    },
    postingData: async function () {
      this.isLoading = true;
      try {
        await arrsettl.postingtrf(this.model);
        this.model.posting = 1;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    unpostData: async function () {
      this.isLoading = true;
      try {
        await arrsettl.postingundotrf(this.model);
        this.model.posting = 0;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    editjv: function () {
      if (this.model.settleKey) {
        this.saveFilter();
        const tanggal = moment(this.model.tglsettl).format("YYYY-MM-DD");
        router.push({
          name: "receivable.editjvfrm",
          params: { nomor: this.model.settleno, tanggal, kodejurnal: "ARSTTL" },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },

    printjv: async function () {
      if (this.model.settleKey) {
        // if ((this.model.posting || 0) == 0) {
        //       toastr.warn('Please do Posting first!');
        // }
        try {
          if ((this.model.posting || 0) == 0) {
            await arpbbadjust.posting(this.model);
            this.model.posting = 1;
          }
          this.showReport = true;
          this.isprintjv = true;
          this.reportUrl = await arpbbadjust.printjv(this.model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        const response = await arpbbadjust.exportXls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    close() {
      router.push("/receivable/home");
    },
  },
};
</script>
